<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="tooltip"
    (click)="toggleTheme()">
    <mat-icon *ngIf="scheme === 'dark' " [svgIcon]="'mat_solid:light_mode'"></mat-icon>
    <mat-icon *ngIf="scheme === 'light' " [svgIcon]="'mat_solid:dark_mode'"></mat-icon>
</button>
